import { scientificNamePartsFor, scientificNamesFrom } from './lib/scientificNames';
import { taxonomyParts } from './lib/scientificText';

/** Format names without changing source text or treating it as HTML. */
export default function ScientificText({ text, sources = [], names = [] }: {
  text: string; sources?: string[]; names?: string[];
}) {
  const parts = scientificNamePartsFor(text, [...names, ...scientificNamesFrom(text, ...sources)])
    .flatMap((part) => part.italic ? [part] : taxonomyParts(part.text));
  return <>{parts.map((part, index) => part.italic
    ? <em className="scientific-name" key={index}>{part.text}</em>
    : part.text)}</>;
}
